// Place all the behaviors and hooks related to the matching controller here.
// All this logic will automatically be available in application.js.
import { select2RemoteAjax } from './select2_remote';

(function() {

$(document).on("turbo:load", function() {

  $('#earning_contact_id').select2(ajax_select);
  if ($("#earning_user_id").is(':visible')) {
    $("#earning_user_id").select2({placeholder: "請求弁護士"});
  }

  if ($("#earning_matter_id").is(':visible')) {
    $("#earning_matter_id").select2({placeholder: "依頼人：事件名", allowClear: true});
    // 事件選択時に関連弁護士プルダウンを更新
    new Select2Cascade($('#earning_matter_id'), $('#earning_user_id'), '/matters/:parentId:/matter_users', {});
  }

  $('#earning_user_id').select2({allowClear: true});
  $('#earning_earning_type').select2();
  $("#earning_raw_amount").on('keyup focusout', calc_tax);
  $('input[name=earning\\[tax_class\\]]:radio').on('change', tax_class_toggle);
  $('input[name=earning\\[consumption_tax\\]]:radio').on('change', calc_tax);
  $('input[name=earning\\[tax_withhold\\]]:radio').on('change', calc_tax);
  calc_tax();

  // 日付検索の動的切り替え
  $(document).on('change', '#date_type', function() {
    const selectedColumn = $(this).val();
    const currentStartDate = $('.date-range-start').val();
    const currentEndDate = $('.date-range-end').val();

    // フォームを再送信
    const $form = $('<form>', {action: location.pathname, method: 'get'});
    $form.append($('<input>', {type: 'hidden', name: 'date_type', value: selectedColumn}));
    $form.append($('<input>', {type: 'hidden', name: `q[${selectedColumn}_gteq]`, value: currentStartDate}));
    $form.append($('<input>', {type: 'hidden', name: `q[${selectedColumn}_lteq]`, value: currentEndDate}));

    // matter_idが存在する場合のみ追加（_one_matterの場合のみ）
    if ($('#q_matter_id').length > 0) {
      $form.append($('<input>', {type: 'hidden', name: "q[matter_id]", value: $('#q_matter_id').val()}));
    }

    $form.appendTo('body');
    $form.submit();
  });
});

const CONSUMPTION_TAX_RATE = 0.1;
const calc_tax = function() {
  const amt = Math.round($("#earning_raw_amount").val());
  if ($.isNumeric(amt)) {
    let consumption_tax, net_amount, raw_amount;
    if (not_taxable()) {
      consumption_tax = 0;
      raw_amount = amt;
      net_amount = amt;
    } else if ($('input[name=earning\\[consumption_tax\\]]:checked').val() === 'inclusive') {
      consumption_tax = Math.round((amt / (1 + CONSUMPTION_TAX_RATE)) * CONSUMPTION_TAX_RATE);
      raw_amount = amt - consumption_tax;
      net_amount = amt;
    } else {
      consumption_tax = Math.round(CONSUMPTION_TAX_RATE * amt);
      raw_amount = amt;
      net_amount = amt + consumption_tax;
    }
    const withholding_amount = calc_with_holding_tax(raw_amount);
    const amount = net_amount - withholding_amount;
    $('#earning_tbl_raw_amount').first().text(raw_amount.toLocaleString());

    // Set table fields
    $('#earning_tbl_consumption_tax_amount').first().text(consumption_tax.toLocaleString());
    $('#earning_tbl_net_amount').first().text(net_amount.toLocaleString());
    $('#earning_tbl_withholding_amount').first().text(withholding_amount.toLocaleString());
    $('#earning_tbl_amount').first().text(amount.toLocaleString());

    // Set hidden inputs
    $("#earning_consumption_tax_amount").val(consumption_tax);
    $("#earning_net_amount").val(Math.round(net_amount));
    $("#earning_withholding_amount").val(withholding_amount);
    $("#earning_amount").val(Math.round(amount));
  }
};


const calc_with_holding_tax = function(amt) {
  if (not_taxable() || ($('input[name=earning\\[tax_withhold\\]]:checked').val() === 'withhold_no')) {
    return 0;
  }
  if (amt <= 1000000) {
    return Math.floor(amt * 0.1021);
  } else {
    return Math.floor(((amt - 1000000) * 0.2042) + 102100);
  }
};

const tax_class_toggle = function() {
  if (not_taxable()) {
    $('input[name=earning\\[consumption_tax\\]]').val(['exclusive']);
    $('input[name=earning\\[tax_withhold\\]]').val(['withhold_no']);
    $('#tax_row').hide();
  } else {
    $('#tax_row').show();
  }
  calc_tax();
};

const not_taxable = () => $('input[name=earning\\[tax_class\\]]:checked').val() === 'non_taxable';

const ajax_select = {
  language: "ja",
  allowClear: true,
  ajax: select2RemoteAjax({
    url: "/contacts.json",
    query: params => ({ search_text_cont_all: params.term })
  }),
  escapeMarkup(markup) { return markup; }, // let our custom formatter work
  minimumInputLength: 1
};

})();
